<template>
    <div>
        <div class="active" v-show="'photodesk-session' == currentStep.key">
            <div class="form-group">
                <label for=""> Channel</label>
                <select class="form-control" name="id_channel" >
                    <option value="">Select a channel</option>
                    <option v-for="channel in channels" :value="channel.id_channel">{{channel.channel_name}}</option>
                </select>
            </div>
            <div class="form-group">
                <label for=""> Session type</label>
                <select class="form-control" name="shoot_type" v-model="shootType">
                    <option value="">Select shoot type</option>
                    <option value="product">Product Shoot</option>
                    <option value="model">Model Shoot</option>
                    <option value="flat">Mannequin/Flats Shoot</option>
                    <option value="bulk_import">Bulk Shoot</option>
                </select>
            </div>

            <div class="form-group">
                <label for=""> Session location</label>
                <select class="form-control" name="shoot_location" v-model="shootLocation">
                    <option value="">Select shoot location</option>
                    <option v-for="location in locations" :value="location.id_client_user">{{location.name_en}}</option>
                </select>
            </div>
            <div class="form-group" v-if="shootType == 'bulk_import'">
                <label for=""> Import Profile</label>
                <select class="form-control" name="id_import_profile">
                    <option value="">Select an import profile</option>
                    <option v-for="profile in importProfiles" :value="profile.id_import_profile">{{profile.import_profile_name_en}}</option>
                </select>

            </div>
        </div>
        <div class="active" v-show="'photodesk-misc' == currentStep.key">
            <div class="form-group">
                <label for=""> Reporting class</label>
                <select class="form-control" name="reporting_class" v-model="reportingClass">
                    <option value="">Select reporting class</option>
                    <option value="isnos">ISNOS</option>
                    <option value="content_check">Content Check</option>
                </select>
            </div>
            <div class="form-group">
                <label> Rack ID</label>
                <textarea class="form-control" name="misc_rack_id" rows="1"></textarea>
            </div>
        </div>
        <div class="active" v-show="'photodesk-contributors' == currentStep.key">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <div class="users-list-w">
                            <div class="user-w with-status status-green">
                                <div class="user-avatar-w">
                                    <div class="user-avatar"><img alt="" :src="user.avatar"></div>
                                </div>
                                <div class="user-name">
                                    <h6 class="user-title">{{user.name}}</h6>
                                    <div class="user-role">You are the photographer for this session</div>
                                </div>
                            </div>
                            <div class="user-w with-status status-green" v-for="user in selectedUsers">
                                <div class="user-avatar-w">
                                    <div class="user-avatar"><img alt="" :src="user.avatar"></div>
                                </div>
                                <div class="user-name">
                                    <h6 class="user-title">{{user.name}}</h6>
                                    <div class="user-role">{{user.role_code}}</div>
                                </div>
                                <th class="">
                                    <span class="btn btn-danger btn-sm" @click="removeUser(user)">Remove</span>
                                </th>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="active" v-show="'photodesk-notes' == currentStep.key">
            <div class="form-group">
                <label> Notes</label>
                <textarea class="form-control" rows="3"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['currentStep', 'channels', 'categories', 'selectedUsers', 'importProfiles', 'locations'],
  data () {
    return {
      selectedProfile: [],
      shootLocation: '',
      shootType: '',
      reportingClass: '',
      user: ''
    }
  },
  mounted () {
    this.getUser()
  },
  methods: {
    getUser () {
      this.user = this.$store.getters.authUser
    },
    removeUser (user) {
      this.$emit('headerInterface', user)
    }
  }
}
</script>
